/*
 *   File : corridor-details.js
 *   Description :
*/

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { APIService } from "../../Service";
import jsonlint from "jsonlint-mod";
import { Modal } from 'bootstrap';
import { toast } from 'react-toastify';

import { CustomTextInput, CustomTextArea } from "../../Component/FormElements";
import { PrimaryButton, SecondaryButton } from "../../Component/Buttons";
import CustomDropdown from "../../Component/FormElements/select";
import Loader from "../../Component/Others/loader";
import { AddCorridorModal } from "../../Component/Modal";

const CorridorDetail = () => {
    const navigate = useNavigate();

    // ---------------- STATES ----------------
    const [countryList, setCountryList] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [loading, setLoading] = useState(false);

    const [countryName, setCountryName] = useState("");
    const [destinationCountry, setDestinationCountry] = useState("");
    const [beneficiaryCurrency, setBeneficiaryCurrency] = useState("");
    const [paymentType, setPaymentType] = useState("");

    // ERROR STATES
    const [beneficiaryCurrencyError, setBeneficiaryCurrencyError] = useState("");
    const [paymentTypeError, setPaymentTypeError] = useState("");

    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    // Channels (max 3)
    const [channels, setChannels] = useState([
        { channel_id: null, channel_type: "", destination_service_tag: "", uri_prefix: "", regex: "" },
        { channel_id: null, channel_type: "", destination_service_tag: "", uri_prefix: "", regex: "" },
        { channel_id: null, channel_type: "", destination_service_tag: "", uri_prefix: "", regex: "" },
    ]);

    // Channel errors
    const [channelErrors, setChannelErrors] = useState([
        { channel_type: "", destination_service_tag: "", uri_prefix: "", regex: "" },
        { channel_type: "", destination_service_tag: "", uri_prefix: "", regex: "" },
        { channel_type: "", destination_service_tag: "", uri_prefix: "", regex: "" },
    ]);

    // ---------------- LOAD COUNTRY LIST ----------------
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        _getCountryList();
    }, []);

    const _getCountryList = () => {
        setLoading(true);
        APIService(false, "corridor/list", {}).then((res) => {
            if (res.status_code === 200) {
                const mapped = res.data.map((item) => ({
                    label: item.name,
                    value: item.id,
                }));

                setCountryList(mapped);

                if (mapped.length > 0) {
                    const first = mapped[0];
                    setSelectedCountry(first);
                    _getCorridorDetail(first.value);
                }
            }
            setLoading(false);
        });
    };

    // ---------------- GET CORRIDOR DETAIL ----------------
    const _getCorridorDetail = (corridorId) => {
        setLoading(true);

        APIService(true, "corridor_master/detail", { corridor_id: corridorId })
            .then((res) => {
                if (res.status_code === 200) {
                    const data = res.data;

                    setCountryName(data.country_name || "");
                    setDestinationCountry(data.destination_iso || "");
                    setBeneficiaryCurrency(data.currency_with_precision || "");
                    setPaymentType(data.payment_type || "");

                    // ALWAYS RESET FULL 3 CHANNELS
                    let clean = [
                        { channel_id: null, channel_type: "", destination_service_tag: "", uri_prefix: "", regex: "" },
                        { channel_id: null, channel_type: "", destination_service_tag: "", uri_prefix: "", regex: "" },
                        { channel_id: null, channel_type: "", destination_service_tag: "", uri_prefix: "", regex: "" },
                    ];

                    // fill only channels returned by API
                    if (Array.isArray(data.channels)) {
                        data.channels.slice(0, 3).forEach((ch, i) => {
                            clean[i] = {
                                channel_id: ch.channel_id || null,
                                channel_type: ch.channel_type || "",
                                destination_service_tag: ch.destination_service_tag || "",
                                uri_prefix: ch.uri_prefix || "",
                                regex: ch.regex || "",
                            };
                        });
                    }

                    setChannels(clean);
                }
                setLoading(false);
            });
    };

    // ---------------- HANDLE CHANNEL INPUT CHANGE ----------------
    const handleChannelChange = (index, field, value) => {
        const updated = [...channels];
        updated[index][field] = value;
        setChannels(updated);

        // clear error
        const err = [...channelErrors];
        err[index][field] = "";
        setChannelErrors(err);
    };

    // ---------------- VALIDATION ----------------

    // const validate = () => {
    //     let valid = true;

    //     // Reset main field errors
    //     setBeneficiaryCurrencyError("");
    //     setPaymentTypeError("");

    //     // Clone channel errors
    //     const tempErr = [...channelErrors];

    //     // ---------- Basic main fields ----------
    //     if (!beneficiaryCurrency.trim()) {
    //         setBeneficiaryCurrencyError("Beneficiary currency is required");
    //         valid = false;
    //     }

    //     if (!paymentType.trim()) {
    //         setPaymentTypeError("Payment type is required");
    //         valid = false;
    //     }

    //     // ---------- CHANNEL 1 (MANDATORY) ----------
    //     const ch1 = channels[0];

    //     // Channel Type
    //     if (!ch1.channel_type.trim()) {
    //         tempErr[0].channel_type = "Channel type is required";
    //         valid = false;
    //     }

    //     // Destination Service Tag
    //     if (!ch1.destination_service_tag.trim()) {
    //         tempErr[0].destination_service_tag = "Destination service tag is required";
    //         valid = false;
    //     }

    //     // URI Prefix
    //     if (!ch1.uri_prefix.trim()) {
    //         tempErr[0].uri_prefix = "Account URI prefix is required";
    //         valid = false;
    //     }

    //     // Regex (Mandatory + Valid JSON)
    //     if (!ch1.regex.trim()) {
    //         tempErr[0].regex = "Regex JSON is required";
    //         valid = false;
    //     } else {
    //         try {
    //             jsonlint.parse(ch1.regex); // validate JSON
    //         } catch (e) {
    //             tempErr[0].regex = `Invalid JSON: ${e.message}`;
    //             valid = false;
    //         }
    //     }

    //     // ---------- CHANNEL 2 & 3 (OPTIONAL JSON VALIDATION) ----------
    //     channels.forEach((ch, i) => {
    //         if (i === 0) return; // skip channel 1, already validated

    //         if (ch.regex.trim()) {
    //             try {
    //                 jsonlint.parse(ch.regex);
    //             } catch (e) {
    //                 tempErr[i].regex = `Invalid JSON: ${e.message}`;
    //                 valid = false;
    //             }
    //         }
    //     });

    //     setChannelErrors(tempErr);
    //     return valid;
    // };


    const validate = () => {
        let valid = true;

        // Reset main field errors
        setBeneficiaryCurrencyError("");
        setPaymentTypeError("");

        // Clone channel errors
        const tempErr = [...channelErrors];

        // ---------- BASIC MAIN FIELDS ----------
        if (!beneficiaryCurrency.trim()) {
            setBeneficiaryCurrencyError("Beneficiary currency is required");
            valid = false;
        }

        if (!paymentType.trim()) {
            setPaymentTypeError("Payment type is required");
            valid = false;
        }

        // ---------- CHANNEL 1 (MANDATORY) ----------
        const ch1 = channels[0];

        // Channel Type
        if (!ch1.channel_type.trim()) {
            tempErr[0].channel_type = "Channel type is required";
            valid = false;
        }

        // Destination Service Tag
        if (!ch1.destination_service_tag.trim()) {
            tempErr[0].destination_service_tag = "Destination service tag is required";
            valid = false;
        }

        // URI Prefix
        if (!ch1.uri_prefix.trim()) {
            tempErr[0].uri_prefix = "Account URI prefix is required";
            valid = false;
        }

        // REGEX JSON (mandatory)
        if (!ch1.regex.trim()) {
            tempErr[0].regex = "Regex JSON is required";
            valid = false;
        } else {
            // Step 1: JSON Syntax Check
            try {
                jsonlint.parse(ch1.regex);
            } catch (e) {
                tempErr[0].regex = `Invalid JSON: ${e.message}`;
                valid = false;
            }

            // Step 2: Parse JSON
            try {
                const parsed = JSON.parse(ch1.regex);

                // Validate "pattern" if present
                if (parsed.pattern !== undefined) {
                    if (typeof parsed.pattern !== "string") {
                        tempErr[0].regex = `"pattern" must be a string`;
                        valid = false;
                    } else if (parsed.pattern.trim().length > 0) {
                        try {
                            new RegExp(parsed.pattern);
                        } catch (e) {
                            tempErr[0].regex = `Invalid regex: ${e.message}`;
                            valid = false;
                        }
                    }
                }

            } catch {
                tempErr[0].regex = "Invalid JSON format";
                valid = false;
            }
        }

        // ---------- CHANNEL 2 & 3 (OPTIONAL JSON + regex validation) ----------
        channels.forEach((ch, i) => {
            if (i === 0) return; // skip channel 1

            if (ch.regex.trim()) {
                // Validate JSON
                try {
                    jsonlint.parse(ch.regex);
                } catch (e) {
                    tempErr[i].regex = `Invalid JSON: ${e.message}`;
                    valid = false;
                    return;
                }

                // Validate "pattern" if present
                try {
                    const parsed = JSON.parse(ch.regex);

                    if (parsed.pattern !== undefined) {
                        if (typeof parsed.pattern !== "string") {
                            tempErr[i].regex = `"pattern" must be a string`;
                            valid = false;
                        } else if (parsed.pattern.trim().length > 0) {
                            try {
                                new RegExp(parsed.pattern);
                            } catch (e) {
                                tempErr[i].regex = `Invalid regex: ${e.message}`;
                                valid = false;
                            }
                        }
                    }

                } catch {
                    tempErr[i].regex = "Invalid JSON format";
                    valid = false;
                }
            }
        });

        setChannelErrors(tempErr);
        return valid;
    };


    // ---------------- SAVE CORRIDOR ----------------
    // const _addOrUpdateCorridor = () => {
    //     if (!validate()) return;

    //     setLoading(true);

    //     const payload = {
    //         corridor_id: selectedCountry?.value,
    //         country_name: countryName,
    //         destination_iso: destinationCountry,
    //         currency_with_precision: beneficiaryCurrency,
    //         payment_type: paymentType,
    //         channels: channels.map((ch) => ({
    //             channel_id: ch.channel_id || null,
    //             channel_type: ch.channel_type,
    //             destination_service_tag: ch.destination_service_tag,
    //             uri_prefix: ch.uri_prefix,
    //             regex: ch.regex,
    //         })),
    //     };

    //     APIService(true, "corridor_master/edit", payload).then((res) => {
    //         if (res.status_code === 200) {
    //             setIsEdit(false);
    //             window.scrollTo({ top: 0, behavior: 'smooth' });
    //             _getCorridorDetail(selectedCountry.value);
    //         }
    //         setLoading(false);
    //     });
    // };

    // const _addOrUpdateCorridor = () => {
    //     if (!validate()) return;

    //     setLoading(true);

    //     // Keep only channels with channel_type
    //     const formattedChannels = channels
    //         .filter(ch => ch.channel_type?.trim())
    //         .map(ch => ({
    //             channel_id: ch.channel_id || null,
    //             channel_type: ch.channel_type,
    //             destination_service_tag: ch.destination_service_tag,
    //             uri_prefix: ch.uri_prefix,
    //             regex: ch.regex,
    //         }));

    //     const payload = {
    //         corridor_id: selectedCountry?.value,
    //         country_name: countryName,
    //         destination_iso: destinationCountry,
    //         currency_with_precision: beneficiaryCurrency,
    //         payment_type: paymentType,
    //         channels: formattedChannels,
    //     };

    //     APIService(true, "corridor_master/edit", payload)
    //         .then((response) => {
    //             if (response.status_code === 200) {

    //                 toast.dismiss();
    //                 toast.success(response.message, {
    //                     type: "success",
    //                     className: "e-toast",
    //                 });

    //                 setIsEdit(false);

    //                 // 🎯 AFTER SAVE — REFRESH FROM API ONLY
    //                 _getCorridorDetail(selectedCountry.value);
    //             } else {
    //                 toast.dismiss();
    //                 toast.error(response.message, {
    //                     type: "error",
    //                     className: "e-toast",
    //                 });
    //             }

    //             setLoading(false);
    //         })
    //         .catch(() => {
    //             toast.dismiss();
    //             toast.error("something went wrong.", {
    //                 type: "error",
    //                 className: "e-toast",
    //             });
    //             setLoading(false);
    //         });
    // };

    const _addOrUpdateCorridor = () => {
        if (!validate()) return;

        setLoading(true);

        const payload = {
            corridor_id: selectedCountry?.value,
            country_name: countryName,
            destination_iso: destinationCountry,
            currency_with_precision: beneficiaryCurrency,
            payment_type: paymentType,
            channels: channels.map(ch => ({
                channel_id: ch.channel_id || null,
                channel_type: ch.channel_type,  // empty allowed
                destination_service_tag: ch.destination_service_tag,
                uri_prefix: ch.uri_prefix,
                regex: ch.regex,
            })),
        };

        APIService(true, "corridor_master/edit", payload)
            .then((response) => {
                toast.dismiss();

                if (response.status_code === 200) {

                    toast.success(response.message, {
                        type: "success",
                        className: "e-toast",
                    });

                    setIsEdit(false);

                    // refresh with fresh API data
                    _getCorridorDetail(selectedCountry.value);

                } else {
                    toast.error(response.message, {
                        type: "error",
                        className: "e-toast",
                    });
                }

                setLoading(false);
            })
            .catch(() => {
                toast.dismiss();
                toast.error("something went wrong.", {
                    type: "error",
                    className: "e-toast",
                });
                setLoading(false);
            });
    };


    useEffect(() => {
        if (openModal) {
            setTimeout(() => {
                const modalEl = document.getElementById("add-corridor-modal");
                if (modalEl) {
                    const modal = new Modal(modalEl);
                    modal.show();
                }
            }, 10);
        }
    }, [openModal]);


    //on click of add button
    const _handleAddCorridor = () => {
        setOpenModal(true);
    };


    //on click of cancel button
    const _handleCancel = () => {
        setIsEdit(false);
        window.scrollTo({ top: 0, behavior: 'smooth' });

        // Reset all error states
        setBeneficiaryCurrencyError("");
        setPaymentTypeError("");

        setChannelErrors([
            { channel_type: "", destination_service_tag: "", uri_prefix: "", regex: "" },
            { channel_type: "", destination_service_tag: "", uri_prefix: "", regex: "" },
            { channel_type: "", destination_service_tag: "", uri_prefix: "", regex: "" },
        ]);

        // Reload original data from API so removed values revert
        if (selectedCountry?.value) {
            _getCorridorDetail(selectedCountry.value);
        }
    };




    // ---------------- UI ----------------
    return (
        <div className="pt-3 padding-98px-bottom padding-32px-lr">
            <div className="row pt-3">
                <div className="col-xl-8 col-lg-8 col-md-7 col-sm-6 col-9 my-auto">
                    <h1 className="e-primary-font e-font-weight-600 e-font-24">Corridor Details</h1>
                </div>
                <div className="d-xl-none d-lg-none d-md-none d-sm-none d-block col-3 text-end my-auto">
                    {!isEdit && selectedCountry && !loading && (
                        <>
                            <img
                                draggable={false}
                                src={require("../../Assets/Images/Home/edit.svg").default}
                                className="me-1"
                                alt="Edit icon"
                            />
                            <span
                                className="e-edit-btn e-primary-font e-font-weight-500 e-font-16 cursor-pointer"
                                onClick={() => setIsEdit(true)}
                            >
                                Edit
                            </span>
                        </>
                    )}
                </div>
                <div className="col-xl-4 col-lg-4 col-md-5 col-sm-6 col-12 text-end my-auto mt-lg-0 mt-md-0 mt-sm-0 mt-3">
                    <PrimaryButton
                        name="Add corridor"
                        className={`e-bg-primary-blue w-50 ${isEdit ? "opacity-70 cursor-not-allowed" : ""}`}
                        disabled={isEdit}
                        onPress={() => {
                            if (isEdit) return;  // Prevent opening while editing
                            _handleAddCorridor();
                        }}
                    />
                </div>
            </div>



            {/* Country Dropdown */}
            <div className="row mt-3 mb-3">
                <div className="col-lg-4 col-md-5 col-sm-8">
                    <CustomDropdown
                        label="Destination Country"
                        options={countryList}
                        value={selectedCountry?.value ?? null}
                        placeholder="Select Country"
                        listClassName={
                            `e-select-overflow ${isEdit ? "cursor-not-allowed opacity-50 pe-none" : ""}`
                        }
                        disabled={isEdit}
                        labelKey="label"
                        valueKey="value"
                        onChange={(s) => {
                            setSelectedCountry(s);
                            if (s?.value) _getCorridorDetail(s.value);
                        }}
                    />
                </div>

                <div className="d-xl-block d-lg-block d-md-block d-sm-block d-none col-lg-4 col-sm-4 text-end my-auto">
                    {!isEdit && selectedCountry && !loading && (

                        <>
                            <img
                                draggable={false}
                                src={require("../../Assets/Images/Home/edit.svg").default}
                                className="me-1"
                                alt="Edit icon"
                            />
                            <span
                                className="e-edit-btn e-primary-font e-font-weight-500 e-font-16 cursor-pointer"
                                onClick={() => setIsEdit(true)}
                            >
                                Edit
                            </span>
                        </>
                    )}
                </div>

            </div>

            {
                loading ?
                    <Loader />
                    :
                    <>
                        {/* FIXED FIELDS */}
                        <div className="row mt-3">
                            <div className="col-lg-4 col-md-5 col-sm-6 pe-0">
                                <CustomTextInput label="Country name" value={countryName} readOnly className="w-100" />
                            </div>

                            <div className="col-lg-4 col-md-5 col-sm-6 pe-0 mt-lg-0 mt-md-0 mt-sm-0 mt-3">
                                <CustomTextInput label="Destination country (ISO-3)" value={destinationCountry} readOnly className="w-100" />
                            </div>
                        </div>

                        {/* Editable Fields */}
                        <div className="row mt-3">
                            <div className="col-lg-4 col-md-5 col-sm-12 pe-0">
                                <CustomTextInput
                                    label="Beneficiary currency and decimal precision"
                                    value={beneficiaryCurrency}
                                    readOnly={!isEdit}
                                    className="w-100"
                                    require
                                    labelStyle="e-font-weight-400"
                                    error={beneficiaryCurrencyError}
                                    handleChange={(v) => {
                                        setBeneficiaryCurrency(v);
                                        setBeneficiaryCurrencyError("");
                                    }}
                                />
                            </div>

                            <div className="col-lg-4 col-md-5 col-sm-12 pe-0 mt-lg-0 mt-md-0 mt-3">
                                <CustomTextInput
                                    label="Payment Type"
                                    value={paymentType}
                                    readOnly={!isEdit}
                                    className="w-100"
                                    require
                                    labelStyle="e-font-weight-400"
                                    error={paymentTypeError}
                                    handleChange={(v) => {
                                        setPaymentType(v);
                                        setPaymentTypeError("");
                                    }}
                                />
                            </div>
                        </div>

                        <h3 className="pt-4 e-primary-font e-font-weight-600 e-font-16">Channel Type Details</h3>

                        {/* CHANNELS */}
                        {channels.map((ch, idx) => (
                            <div
                                key={idx}
                                className="mb-4 pb-2"
                                style={{
                                    borderBottom: idx !== channels.length - 1 ? "1px dashed #ccc" : "none",
                                }}
                            >
                                <div className="row mt-3">
                                    <div className="col-lg-4 col-md-5 col-sm-6 pe-0">
                                        <CustomTextInput
                                            label={`${idx + 1}. Channel Type`}
                                            placeholder="Enter channel type"
                                            value={ch.channel_type}
                                            readOnly={!isEdit}
                                            require={idx === 0}    // ONLY FIRST CHANNEL REQUIRED
                                            labelStyle="e-font-weight-400"
                                            className="w-100"
                                            error={channelErrors[idx].channel_type}
                                            handleChange={(v) => handleChannelChange(idx, "channel_type", v)}
                                        />
                                    </div>

                                    <div className="col-lg-4 col-md-5 col-sm-6 pe-0">
                                        <CustomTextInput
                                            label="Destination Service Tag"
                                            placeholder="Enter tag"
                                            value={ch.destination_service_tag}
                                            readOnly={!isEdit}
                                            require={idx === 0}    // ONLY FIRST CHANNEL REQUIRED
                                            labelStyle="e-font-weight-400"
                                            className="w-100"
                                            error={channelErrors[idx].destination_service_tag}
                                            handleChange={(v) => handleChannelChange(idx, "destination_service_tag", v)}
                                        />
                                    </div>
                                </div>

                                <div className="row mt-3">
                                    <div className="col-lg-4 col-md-5 col-sm-6 pe-0">
                                        <CustomTextInput
                                            label="Account URI Prefix"
                                            placeholder="Enter URI prefix"
                                            value={ch.uri_prefix}
                                            readOnly={!isEdit}
                                            require={idx === 0}   // ONLY FIRST CHANNEL REQUIRED
                                            labelStyle="e-font-weight-400"
                                            className="w-100"
                                            error={channelErrors[idx].uri_prefix}
                                            handleChange={(v) => handleChannelChange(idx, "uri_prefix", v)}
                                        />
                                    </div>

                                    <div className="col-lg-4 col-md-5 col-sm-6 pe-0">
                                        <CustomTextArea
                                            label="Regex"
                                            placeholder={`Eg:  {
  "pattern": "^[A-Za-z0-9]+$",
  "description": "Allows only alphanumeric characters"
}`}
                                            value={ch.regex}
                                            rows={5}
                                            readOnly={!isEdit}
                                            require={idx === 0}   // ONLY FIRST CHANNEL REQUIRED
                                            labelStyle="e-font-weight-400"
                                            className="w-100"
                                            error={channelErrors[idx].regex}
                                            handleChange={(v) => handleChannelChange(idx, "regex", v)}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}

                    </>
            }

            {/* SAVE / CANCEL BUTTONS */}
            {isEdit && (
                <div className="row pt-3 pb-5">
                    <div className="col-lg-8 pe-0 d-flex justify-content-end gap-3">
                        <SecondaryButton name="Cancel"
                            onPress={_handleCancel} />
                        <PrimaryButton
                            name="Save"
                            status={loading}
                            className="w-16 e-bg-primary-blue"
                            onPress={_addOrUpdateCorridor}
                        />
                    </div>
                </div>
            )}

            {/* Add Corridor Modal */}
            {openModal && (
                <AddCorridorModal
                    handleClose={() => setOpenModal(false)}
                    onSuccess={_getCountryList} />
            )}


        </div>
    );
};

export default CorridorDetail;
